module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.isLoading,
      "text": "加载中"
    }
  }), _vm._v(" "), _c('top-tips'), _vm._v(" "), _c('div', {
    staticClass: "remote-panel"
  }, [_c('div', {
    staticClass: "top-btns"
  }, [_c('div', {
    staticClass: "fan-img"
  }, [_c('img', {
    attrs: {
      "src": require('../../../assets/img/device/fan.png'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "power",
      "value": _vm.currentRid['1'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "speed",
      "value": _vm.currentRid['9367'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "putwind",
      "value": _vm.currentRid['9362'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "windClass",
      "value": _vm.currentRid['9372'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "anion",
      "value": _vm.currentRid['31'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "atomization",
      "value": _vm.currentRid['1105'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "flex-demo"
  }, [_c('icon-button', {
    attrs: {
      "title": "akey",
      "value": _vm.currentRid['1762'],
      "onClick": _vm.onClick,
      "isShowTitle": true
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('action-button', {
    attrs: {
      "totalCount": _vm.irDataList.length + 1,
      "currentHandle": _vm.current,
      "nextHandle": _vm.next,
      "preHandle": _vm.pre
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680a718a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/fan/Index.vue
// module id = 906
// module chunks = 1